import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, Option, FormLabel, Box } from '@mui/joy';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { red } from '@mui/material/colors';

export default function InvoicedOptionList({
    label,
    required,
    invoiced,
    setInvoiced,
    showAll = false,
    disabled = false,
}) {
    const { t } = useTranslation('ui');
    const resolvedLabel = label ?? t('widgets.invoiceStatus');
    return (
        <Box sx={{ marginBottom: 2 }}>
            <FormLabel
                sx={{
                    fontWeight: 600,
                    color: '#555',
                    marginBottom: '6px',
                    fontSize: '14px',
                }}
            >
                {required ? `${resolvedLabel} *` : resolvedLabel}
            </FormLabel>
            <Select
                value={invoiced}
                onChange={(e, newValue) => setInvoiced(newValue)}
                required={required}
                disabled={disabled}
                placeholder={t('widgets.selectInvoiceStatus')}
                sx={{
                    backgroundColor: '#f7f9fc',
                    borderRadius: '8px',
                    padding: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    '&:hover': {
                        borderColor: '#5f09c2',
                    },
                    '&:focus': {
                        borderColor: '#5f09c2',
                        outline: 'none',
                        boxShadow: '0 0 6px rgba(0, 123, 255, 0.5)',
                    },
                    '&[disabled]': {
                        backgroundColor: '#e9ecef',
                        color: '#6c757d',
                        cursor: 'not-allowed',
                    },
                }}
            >
                {showAll && <Option value="">{t('actions.all')}</Option>}
                <Option value={true}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <ListAltIcon color='success' />
                        {t('widgets.invoiced')}
                    </Box>
                </Option>
                <Option value={false}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <ListAltIcon sx={{ color: red[500] }} />
                        {t('widgets.notInvoiced')}
                    </Box>
                </Option>
            </Select>
        </Box>
    );
}
